module.exports = __webpack_public_path__ + "static/media/report.2b5c826a.svg";